export { useSlideLessonContinueMutation } from "#use-slide-lesson-continue-mutation";
